import {Injectable, signal} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Params} from '@angular/router';
import {ICompany, ICompanyTableData} from '@lib-typing/company.interface';
import {CommonTableData} from '@lib-ui/common-table/models/common-table-data.class';
import {CompanyService} from '@lib-services/company.service';
import {MessageService} from '@lib-services/message.service';
import {ICommonTableConfig, ICommonTableService} from '@lib-ui/common-table/models/common-table.interface';
import {IPaginatedResponse} from '@lib-typing/response.interface';

@Injectable({
    providedIn: 'root',
})
export class CompanyTableService implements ICommonTableService<ICompany> {
    public tableData$: BehaviorSubject<CommonTableData<ICompany>> = new BehaviorSubject<CommonTableData<ICompany>>(new CommonTableData());
    defaultFilterParams = {
        sortBy: 'createdAt:DESC',
    };
    private readonly commonTableData = new CommonTableData();
    loading = signal<boolean>(false);

    constructor(private companyService: CompanyService, private messageService: MessageService) {}

    updateData(config: ICommonTableConfig): void {
        this.loading.set(true);
        this.companyService
            .getCompanies(this.createSearchParams(config))
            .subscribe({
                next: response => {
                    this.tableData$.next(new CommonTableData(this.transformData(response)));
                },
                error: () => this.messageService.errorMessage('Ошибка загрузки списка компаний'),
            })
            .add(() => this.loading.set(false));
    }

    createSearchParams(config: ICommonTableConfig): Params {
        this.commonTableData.data.length = 0;
        const { pageIndex, itemsPerPage } = config.paginatorConfig;
        const { filters } = config;

        let searchParams: Params = {
            ...this.defaultFilterParams,
            limit: itemsPerPage.toString(),
        };

        if (pageIndex) {
            searchParams = {
                ...searchParams,
                page: pageIndex.toString(),
            };
        }

        if (filters) {
            Object.entries(filters).forEach(([key, value]) => {
                if (value) {
                    let filterValue;

                    switch (key) {
                    case 'name':
                        filterValue = `$ilike:${value}`;
                        break;
                    default:
                        filterValue = `${value}`;
                    }
                    searchParams = {
                        ...searchParams,
                        [`filter.${key}`]: filterValue,
                    };
                }
            });
        }

        return searchParams;
    }

    transformData(response: IPaginatedResponse<ICompany>): IPaginatedResponse<ICompanyTableData> {
        const transformedData = response.data.map(project => {
            return {
                id: project.id,
                createdAt: project.createdAt,
                updatedAt: project.updatedAt,
                name: project.name,
            } as ICompanyTableData;

        });
        // Return a new response object with transformed data
        return {
            ...response,
            data: transformedData
        };
    }
}
